module.exports = __webpack_public_path__ + "files/46661d6d65debc63884004fed6e37e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Exo-2-regular.svg
// module id = 610
// module chunks = 60